<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{modalTitle}} </div>
        <div class="modal-body">
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="nothing()" *ngIf="formGroup">
                <div class="col-container">
                    <div class="col col-1">
                        <frg-form-input label="Valeur par défaut" id="defaultValue" type="text"
                            placeholder="Valeur par défaut" [formGroup]="formGroup"
                            [control]="formGroup.get('defaultValue')" class="form-input default">
                        </frg-form-input>
                        Arborescence des choix
                        <div class="tree" cdkDropList (cdkDropListDropped)="dropped($event)" id="treeDrop"
                            cdkDropListConnectedTo="table2">
                            <mat-tree #treeSelector [dataSource]="dataSource" [treeControl]="treeControl"
                                class="example-tree">
                                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding cdkDropList
                                    (cdkDropListDropped)="dropped($event, node)" [id]="'treeNode_'+node.id"
                                    cdkDropListConnectedTo="table2">
                                    <button mat-icon-button disabled></button>
                                    {{node.name}}
                                </mat-tree-node>

                                <mat-tree-node class="mat-nested-tree-node" *matTreeNodeDef="let node;when: hasChild"
                                    matTreeNodePadding cdkDropList (cdkDropListDropped)="dropped($event, node)"
                                    [id]="'treeNode_'+node.id" cdkDropListConnectedTo="table2">
                                    <div class="mat-tree-node">
                                        <button mat-icon-button matTreeNodeToggle
                                            [attr.aria-label]="'Toggle ' + node.name">
                                            <mat-icon class="mat-icon-rtl-mirror">
                                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                            </mat-icon>
                                        </button>
                                        {{node.name}}
                                    </div>
                                </mat-tree-node>
                            </mat-tree>
                        </div>
                        <frg-button class="reset-tree" [type]="'button'" [backgroundColor]="'var(--danger)'"
                            (mousedown)="resetDataSource()">
                            Vider l'arbre</frg-button>
                    </div>
                    <div class="col col-2">
                        <form [formGroup]="listeGroup" class="inline-inputs" (ngSubmit)="onSubmitListe()"
                            *ngIf="listeGroup">
                            <frg-form-input id="listeName" type="text" [formGroup]="listeGroup"
                                [control]="listeGroup.get('listeName')" class="form-input"
                                placeholder="Nom de la liste">
                            </frg-form-input>
                            <frg-button [type]="'button'" (mousedown)="onSubmitListe()"
                                [backgroundColor]="'var(--secondary)'" class="button-line">
                                Ajouter une liste</frg-button>
                        </form>
                        Vos listes de choix
                        <frg-table #table2 [keysBody]="listesBodyTable" [keysColumn]="listesColumnTable"
                            tableButton2="assets/icons/edit.svg" (onClick2)="editListe($event)" class="table"
                            [dragDrop]="true" idDropTable="table2" [idConnectedTable]='linkedIds'>
                        </frg-table>
                    </div>
                    <div class="col col-2">
                        <form [formGroup]="choixGroup" class="inline-inputs" (ngSubmit)="onSubmitChoix()"
                            *ngIf="choixGroup">
                            <frg-form-input placeholder="Nom du choix" id="choixName" type="text"
                                [formGroup]="choixGroup" [control]="choixGroup.get('choixName')" class="form-input">
                            </frg-form-input>
                            <frg-button [type]="'button'" (mousedown)="onSubmitChoix()"
                                [backgroundColor]="'var(--secondary)'" class="button-line">
                                Ajouter un choix</frg-button>
                        </form>
                        Choix de la liste {{ editingListe ? editingListe.nom : '--'}}
                        <frg-table [keysBody]="choixBodyTable" [keysColumn]="choixColumnTable"
                            tableButton1="assets/icons/trash.svg" (onClick1)="deleteChoix($event)" class="table">
                        </frg-table>
                    </div>
                </div>
                <div class="button-wrapper">
                    <frg-button [type]="'reset'" (activated)="closeAddEditModal()"
                        [backgroundColor]="'var(--darkest-primary)'">Annuler
                    </frg-button>
                    <frg-button id="subButton" [disabled]="isSubmitDisabled" (mousedown)="onSubmit($event)"
                        [type]="'button'">
                        Enregistrer l'aide à la saisie</frg-button>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>